export function generateTitle(title) {
  return this.$t('customize.' + title) // $t :this method from vue-i18n ,inject in @/lang/index.js
}

export function generateCustomizeString(String) {
  return this.$t('customize.' + String)
}

export function generateShopString(String) {
  return this.$t('openShop.' + String)
}
